import { news as getNews } from '@r1-frontend/api-domru/content-static/v2/news';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ErrorPage from '~/pages/_error';
import { DetailNews } from '~/src/components/News/detail-news';
import Layout from '~/src/features/_layout';
import * as base from '~/src/helpers/basePageFunc';
import getRequester from '~/src/helpers/getRequester';
import { setNewsResponse } from '~/src/store/actions/news';
import { getCurrentCity, getHostname, selectCompanyName } from '~/src/store/selectors/city';
import * as newsSelectors from '~/src/store/selectors/news';

class NewsAliasPage extends Component {
    static propTypes = {
        aliasNews: PropTypes.object.isRequired,
        actualNews: PropTypes.array,
        currentCity: PropTypes.object,
        hostname: PropTypes.string,
        alias: PropTypes.string.isRequired,
        companyName: PropTypes.string,
    }

    static defaultProps = {
        actualNews: [],
        currentCity: {},
        hostname: '',
        companyName: 'Дом.ру',
    }

    static async getInitialProps(options) {
        await base.initialProps(options);

        const { store, query, res, req } = options;
        const { alias } = query;
        const doRequest = getRequester(req);
        const state = store.getState();
        const { city } = store.getState();
        const { provider: { providerId } } = city;
        const currentCity = getCurrentCity(state);
        const hostname = getHostname(state);
        const companyName = selectCompanyName(state);

        /* Получаем выбранную новость и новости для списка актуальных новостей */
        const newsAlias = encodeURIComponent(alias);
        const [newsRespByAlias, newsResp] = await Promise.all([
            doRequest.apiContentStatic(
                getNews(providerId, {
                    newsAlias,
                    perPage: 0,
                    sort: '-activeFrom',
                    page: 1,
                    hideFutureNews: true,
                    withCategoriesInfo: true,
                    hidden: false,
                }),
            ),
            doRequest.apiContentStatic(
                getNews(providerId, {
                    sort: '-activeFrom',
                    page: 1,
                    hideFutureNews: true,
                    withCategoriesInfo: true,
                    hidden: false,
                }),
            ),
        ]);

        store.dispatch(setNewsResponse({ response: newsRespByAlias, alias: newsAlias }));
        store.dispatch(setNewsResponse({ response: newsResp }));

        const aliasNews = newsSelectors.selectNewsByAlias(store.getState(), alias);
        if (!aliasNews && res) {
            res.statusCode = 404;
        }

        return { alias, aliasNews, currentCity, companyName, hostname };
    }

    render() {
        const { aliasNews, actualNews, currentCity, alias, hostname, companyName } = this.props;

        if (!aliasNews) {
            return <ErrorPage statusCode={404}/>;
        }

        const { title } = aliasNews;
        const { cityIn } = currentCity;

        return (
            <Layout
                title={`${title} | Новости ${companyName} в ${cityIn}`}
                description={`${title}. Анонсы кинопремьер, конкурсов и других событий. Актуальные новости и акции провайдера ${companyName} в ${cityIn}`}
                withMenu={true}
                withChat={true}
                withFooter={true}
                url={`https://${hostname}/news/${alias}`}
                image={aliasNews.image}
            >
                <DetailNews item={aliasNews} cityIn={cityIn} actualNews={actualNews} hostname={hostname} />
            </Layout>
        );
    }
}

const mapStateToProps = (state, props) => {
    const { alias } = props;
    return {
        actualNews: newsSelectors.selectNewsWisoutAlias(state, alias),
        aliasNews: newsSelectors.selectNewsByAlias(state, alias),
    };
};


export default connect(mapStateToProps)(NewsAliasPage);
